import React, { useContext } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { ButtonBase } from "@material-ui/core";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import AppContext from "../../context/store";

const StyledNavLink = styled(NavLink)`
  &.nav-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: transparent;
    height: 4.85vh;
    min-height: 40px;
    max-height: 60px;
    padding: 4px 15px 4px 8px !important;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    text-align: left;
    letter-spacing: -0.25px;
    text-decoration: none;
    transition: all 0.3s ease;
    border-radius: 8px !important;
    margin: 0;

    svg {
      font-size: 20px !important;
      float: left;
      margin-right: 12px;
      transition: all 0.3s ease;
    }

    span {
      line-height: 1.4;
      padding-left: 5px;
      font-weight: 400;
    }

    &.closed {
      justify-content: center;
      padding: 4px 0 !important;
      width: 100%;
      
      svg {
        margin-right: 0;
        margin-left: 0;
        transition: all 0.3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        left: 0;
        right: 0;
        margin: 0 auto;
        transform: scale(1);
      }
      
      span {
        display: none !important;
        opacity: 0;
        width: 0;
        visibility: hidden;
      }
      
      &.active {
        background: rgba(255, 255, 255, 0.25);
        box-shadow: 0 0px 8px rgba(255, 255, 255, 0.3);
        
        svg {
          transform: scale(1);
        }
        
        &::before {
          display: none;
        }
      }
      
      &:hover {
        background: rgba(255, 255, 255, 0.15);
        
        svg {
          transform: scale(1);
        }
        
        &::before {
          display: none;
        }
      }
    }

    &.opened {
      svg {
        margin-right: 14px;
        transform: scale(1);
      }
      
      span {
        padding-left: 0;
      }
    }
  }
`;

const NavigationItem = ({
  history,
  disabled,
  to,
  title,
  icon: Icon,
  onClick,
  prefixTitle,
  themeType,
  menuStatus,
  disableRipple,
  old,
  isNew,
}) => {
  const context = useContext(AppContext);

  return (
    <>
      {window.location.pathname.includes(to) && (
        <Helmet>
          <title>{prefixTitle + " - " + title}</title>
        </Helmet>
      )}
      <ButtonBase
        disableRipple={disableRipple}
        disabled={disabled}
        style={{
          opacity: disabled ? 0.4 : 1,
          marginBottom: "1px",
        }}
        onClick={() => onClick && onClick()}
      >
        <StyledNavLink
          className={`btn nav-item ${themeType} ${menuStatus ? "opened" : "closed"} ${old && "old"} ${isNew ? "new-item" : ""}`}
          activeClassName="active"
          to={to}
          data-new-text={context.t("appointments.detail.statusNew")}
        >
          <Icon />
          <span className={`limited-line-1 ${old && "old"}`} label={to}>
            {title}
          </span>
        </StyledNavLink>
      </ButtonBase>
    </>
  );
};

export default withRouter(NavigationItem);
